import React, { useEffect } from "react";
import { useSelector } from 'react-redux'
import { AllowedAccess } from 'react-permission-role'
import { useForm } from '../../../../hooks/'
import Swal from 'sweetalert2'
import { Button, Card, CardContent, FormControl, Grid, MenuItem, TextField } from "@mui/material";
import { LinearLoading } from "common";

const FormBank = ({ useFetchInit }) => {

    const {
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Formularios
    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen

    // ------------------------------------------------ FetchData
    const { fetchSpecificBank: { loadingFetchSpecificBank } } = FetchData

    // ------------------------------------------------ Actions
    const { onSubmitForm, handleClickHideForm } = Actions


    return (
        <div className='content'>
            <Card style={{ zIndex: '1' }}>
                <CardContent>

                    <div className='h4 mt-1 mb-1'>
                        {formState.idbank > 0
                            ? 'Actualizar Registro de Banco'
                            : 'Crear Registro de Banco'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificBank && (<LinearLoading />)}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="name"
                                        name="name"
                                        value={formState.name}
                                        onChange={onInputChange}
                                        label='Nombre del Banco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="currency_type"
                                        name="currency_type"
                                        value={formState.currency_type}
                                        onChange={onInputChange}
                                        label='Moneda'
                                        select
                                        size="small"
                                        variant="standard"
                                        required
                                    >
                                        <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                        <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{ background: "#4b4b4c", borderRadius: '5px' }}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ background: "#ef8157", borderRadius: '5px' }}
                                        variant="contained"
                                        type='button'
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}

export {
    FormBank
}